<script setup>
import { ref, computed, onBeforeUnmount, onMounted } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useShopify } from '@/stores/shopify'
import CartDisplay from '@/components/Shopify/CartDisplay.vue'
import MainNavigation from '@/components/MainNavigation.vue'
import ButtonDefault from './atoms/ButtonDefault.vue'
import LogoColored from './logos/LogoColored.vue'
import { useStateStore } from '@/stores/state.store'
import { storeToRefs } from 'pinia'
import { useCart } from '@/router/cart'
import eventBus from '@/eventBus'

const shopify = useShopify()
const router = useRouter()
const state = useStateStore()
const { navigationOpen } = storeToRefs(state)

const { openCart } = useCart()

const backgroundColor = ref(null);
const logoColor = ref('#242635');
const show = ref(true);

const style = computed(() => {
  return {
    backgroundColor: backgroundColor.value,
    color: logoColor.value,
  }
})

router.beforeEach((route) => {
  if (route.meta) {
    backgroundColor.value = route.meta.backgroundColor ?? '#fff';
    logoColor.value = route.meta.logoColor ?? '#242635';
    show.value = !route.meta.disableHeader ?? true;
  }
})

onMounted(() => {
  eventBus.$on('cart-added-items', () => {
    shopify
      .fetchCart(shopify.cartId)
      .then((result) => {
        shopify.updateCart(result.cart)
        openCart()
      });
  })
})

onBeforeUnmount(() => {
  eventBus.$off('cart-added-items')
})

</script>

<template>
  <header id="header" v-if="show" class="header" :style="style">
    <a href="https://www.wyrld.de/" class="header__logo">
      <LogoColored :color="logoColor" />
    </a>

    <div class="header__controls">
      <ButtonDefault icon="Cart" class="cart__button icon-28" :badge="shopify.cartLines" @click="openCart" icon-only />
      <ButtonDefault class="icon-28" @click="navigationOpen = true" aria-label="Open menu" icon="Menu" icon-only buttonType="transparent" />
    </div>
  </header>

  <MainNavigation v-model="navigationOpen" />
  <CartDisplay />
</template>

<style lang="scss">
@use '@styles/sass_variables.scss' as *;

@media screen and (min-width: $breakpoint-medium) {
.icon-28 {
  /*
  svg {
      width: 28px;
      height: 28px;
    }
  */
  }
}
</style>

<style lang="scss" scoped>
@use '@styles/sass_variables.scss' as *;

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 20px 24px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100;
  height: var(--header-height);
  
  // Make the header transparent to mouse events by default
  pointer-events: none;
  
  // Ensure the logo and controls still capture pointer events
  .header__logo, .header__controls {
    pointer-events: auto;
  }

  &__logo {
    display: inline-block;
    padding-top: 4px;
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  @media screen and (min-width: $breakpoint-medium) {
    padding: 24px 24px 20px 24px;
  }
}

.cart__button {
  display: none;
  @media screen and (max-width: $breakpoint-large) {
  }
}
</style>
